export const sanitizeSportNameForTyping = (value) => {
  if (typeof value !== 'string') return '';
  return value.replace(/[^A-Za-z ]+/g, '');
};

export const normalizeSportNameInput = (value) => {
  return sanitizeSportNameForTyping(value).replace(/\s+/g, ' ').trim();
};

export const toSportKey = (value) => normalizeSportNameInput(value).toLowerCase();

export const formatSportDisplayName = (sport) => {
  if (!sport || typeof sport !== 'string') return '';
  return sport
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
